export default {
  auth: {
    login: 'login',
    resetPassowrd: 'reset-wachtwoord',
    forgotPassword: 'wachtwoord-vergeten',
  },
  myRequests: 'mijn-aanvragen',
  myProfile: 'mijn-profiel',
  requestPortfolio: 'portefeuille-aanvraag',
  quickscan: 'quickscan',
  onboarding: 'onboarding',
};
